import { Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent } from '../../../../core/shared/grid/grid.component';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomersRest } from '../../customers.rest';
import { CustomerEmployee, Customer } from '../../customers.model';
import { ObjectToSelect } from '../../../../core/shared/objectToSelect.model';
import { EmployeesRest } from '../../../employees/employee.rest';
import { Employee } from '../../../employees/employee.model';
import { HasPermissions, Permissions } from '../../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../../core/services/permissions/permissions.service';
import { EmployeeIdSelectionComponent } from '../../../../core/shared/employee-selection/employee-id-selection.component';
import { EmployeeModalComponent } from '../../../employees/employee-modal/employee-modal.component';

@Component({
  selector: 'app-customer-employees',
  templateUrl: './customer-employees.component.html'
})
export class CustomerEmployeesComponent implements OnInit, HasPermissions {
  @ViewChild(GridComponent) grid: GridComponent;
  private customer: Customer;

  private headers = [
    { displayName: 'Pracownik', propertyName: 'employeeFullName', propertyType: 'string' },
    { displayName: 'Email', propertyName: 'email', propertyType: 'string' },
    { displayName: 'Telefon', propertyName: 'phone', propertyType: 'string' }
  ];

  constructor(private router: Router, private route: ActivatedRoute, private permissionsService: PermissionsService,
    private rest: CustomersRest, private employeeRest: EmployeesRest) { }

  @ViewChild(EmployeeIdSelectionComponent) public employeeSelectionModal: EmployeeIdSelectionComponent;
  @ViewChild(EmployeeModalComponent) public employeeModal: EmployeeModalComponent;

  permissions: Permissions;
  setPermissions(claimType: string): void {
    this.permissions = this.permissionsService.getUserPermissions(claimType);
  }

  ngOnInit() {
  }

  public setModel(customer: Customer) {
    this.customer = customer;
    this.setPermissions('CustomerEmployee');
  }

  private getActionButtons() {
    return [];
  }

  private editEmployee(row: CustomerEmployee) {
    const action = this.employeeRest.getEmployee;
    action.call(this.rest, row.employeeId).subscribe((employee: Employee) => {
      if (employee) {
        this.employeeModal.setModel(employee, false);
      }
    });
  }

  private removeEmployee(row: CustomerEmployee) {

    let message = `Czy na pewno usunąć przypisanie pracownika ${row.employeeFullName} do obecnego kontrahenta?`;
    sweetAlert(message, {
      buttons: {
        yes: {
          text: "Tak",
          value: "yes"
        },
        no: {
          text: "Nie",
          value: "no",
        }
      }
    })
      .then((value) => {
        switch (value) {
          case "yes":
            if (row.id != null) {
              const action = this.rest.removeCustomerEmployee;
              action.call(this.rest, row.id).subscribe();
            }

            this.customer.employees.splice(this.customer.employees.indexOf(row), 1);
            this.grid.refreshData();
            break;
        }
      });
  }

  private addEmployee() {
    const action = this.rest.getEmployeesToAdd;
    action.call(this.rest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        var employeeIds = this.customer.employees.map(x => x.employeeId)
        this.employeeSelectionModal.selectEmployee(result, employeeIds);
      }
    });
  }

  public onSuccessOperation(value) {
    if (value.isSuccess) {
      if (value.isNew) {
        const employee = new CustomerEmployee();
        if (value.isSaved) {
          employee.id = value.employee.id;
        }
        employee.employeeId = value.isSaved ? value.employee.employeeId : value.employee.id;
        employee.email = value.employee.email;
        employee.employeeFullName = value.isSaved ? value.employee.employeeFullName : value.employee.fullName;
        employee.phone = value.employee.phone;
        this.customer.employees.push(employee);
      } else {
        const employeeToEdit = this.customer.employees.find(x => x.employeeId === value.employee.id);
        employeeToEdit.employeeFullName = value.employee.fullName;
        employeeToEdit.email = value.employee.email;
        employeeToEdit.phone = value.employee.phone;
      }

      this.grid.refreshData();
    }
  }

  public onSuccessEmployeeOperation(event) {
    if (event.isSuccess) {
      var employeeId = event.selectedEmployeeId;
      //todo ask if you shure
      this.rest.addCustomerEmployee(this.customer.id, employeeId).subscribe((result: CustomerEmployee) => {
        if (result) {
          console.log("CustomerEmployeesComponent -> onSuccessEmployeeOperation -> result", result)
          this.customer.employees.push(result)
          this.grid.refreshData();
        }
      });
    }
  }
}

